export default __webpack_public_path__ + "static/media/acct-report-actions.d751e07e.png";